<template>
  <div class="d-flex p-20 justify-content-center" id="stage-outer">
    <upload-box v-if="currentJob.getActiveStageJob().mainJob === null"></upload-box>
    <div id="magic-stage" class="w-100 h-100">
    <magic-canvas v-if="currentJob.getActiveStageJob().mainJob?.apiJob?.output.length > 0"></magic-canvas>
    </div>
  </div>
</template>
<script>
import current_job from "../../mixins/current_job.mixin";
import store from "../../mixins/store.mixin";
import UploadBox from "../Elements/UploadBox.vue";
import MagicCanvas from "./MagicCanvas.vue";

export default {
  name: "Stage",
  props: {},
  components: {MagicCanvas, UploadBox},
  mixins: [
    current_job,
    store
  ],
  data() {
    return {};
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {},
  computed: {}
};
</script>
<style lang="scss">
#stage-outer {
  flex: 1 1 auto;
  overflow: hidden;
}
</style>
